// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.piercing {
  display: flex;
  flex-direction: row;
  position: relative;
  filter: blur(100px);
  position: relative;
  animation: blurry 2s ease-in-out forwards;
  gap: 1em;
  font-family: "Varela Round";
  padding: 0;
  z-index: 1;
  transform: translate3d(0, 0, 0.1px);
}
.piercing_container {
  display: flex;
  margin-top: 8em;
  flex-direction: column;
  width: 70%;
  height: 50em;
  position: relative;
  gap: 4em;
  font-family: "Varela Round";
  justify-content: baseline;
  padding: 2em;
  overflow-y: scroll;
  z-index: 1;
  transform: translate3d(0, 0, 0.1px);
  animation: fadeIn 0.3s ease-in-out forwards;
  transition: all 10s cubic-bezier(0.77, 0, 0.175, 1);
}
.piercing_instructions {
  width: 100%;
}
.piercing_instructions > p {
  color: #f3f3f3;
  font-size: 1.2em;
}
.piercing_instructions > h2 {
  color: #ffc917;
}
.piercing_prices {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  color: #f3f3f3;
}
.piercing_prices_items {
  width: 40%;
}
.piercing_prices_items > h2 {
  color: #ffc917;
}
.piercing_prices_items > li {
  margin: 2em;
  font-size: 1.2em;
}
.piercing_artist {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 0.5em;
  animation: fadeIn 0.3s ease-in-out forwards;
  transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);
}
.piercing_form {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 0.5em;
  animation: fadeIn 0.3s ease-in-out forwards;
  transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);
}

.overlay-piercing-menu {
  display: flex;
  flex-direction: column;
  gap: 2em;
  width: 25%;
  height: 50em;
  opacity: 1;
  position: relative;
  background-image: linear-gradient(to top, #050505, #352336, #753753, #b84f57, #eb7847, #eb7847, #eb7847, #eb7847, #b84f57, #753753, #352336, #050505);
  z-index: 5;
}
.overlay-piercing-menu_title {
  margin-top: 10em;
}
.overlay-piercing-menu_subtitle {
  font-family: "Varela Round";
  font-size: 11px;
  letter-spacing: 5px;
  line-height: 2em;
  color: white;
  text-transform: uppercase;
  position: relative;
  padding: 1em 4em;
}
.overlay-piercing-menu_shirts {
  cursor: pointer;
  position: relative;
  top: 20%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(0, 0, 0);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-piercing-menu_shirts_img {
  width: 4em;
  height: 4em;
}
.overlay-piercing-menu_shirts_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-piercing-menu_shirts_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-piercing-menu_shirts_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-piercing-menu_shirts:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-piercing-menu_shirts:hover_title_top {
  color: black;
}
.overlay-piercing-menu_tattoo-care {
  cursor: pointer;
  position: relative;
  top: 22%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(136, 136, 138);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-piercing-menu_tattoo-care_img {
  width: 4em;
  height: 4em;
}
.overlay-piercing-menu_tattoo-care_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-piercing-menu_tattoo-care_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-piercing-menu_tattoo-care_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-piercing-menu_tattoo-care:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-piercing-menu_tattoo-care:hover_title_top {
  color: black;
}
.overlay-piercing-menu_jewelry {
  cursor: pointer;
  position: relative;
  top: 24%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(136, 136, 138);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-piercing-menu_jewelry_img {
  width: 4em;
  height: 4em;
  border-radius: 4px;
  overflow: hidden;
}
.overlay-piercing-menu_jewelry_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-piercing-menu_jewelry_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-piercing-menu_jewelry_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-piercing-menu_jewelry:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-piercing-menu_jewelry:hover_title_top {
  color: black;
}

img {
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
  image-rendering: auto;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes blurry {
  0% {
    filter: blur(100px);
  }
  100% {
    filter: blur(0px);
  }
}
@keyframes flickerL {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  100% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
}
@keyframes flickerO {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.66667% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  73.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  74% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  74.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  75.33333% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  75.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  94.44444% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
@keyframes flickerA {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.86667% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.88889% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerD {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.31111% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerI {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.75556% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerN {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.2% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerG {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.64444% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
#p-mobile li,
#sh-mobile li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.4vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: #f3f3f3;
}

#p {
  position: absolute;
  top: 20%;
  left: 0%;
  height: 5vw;
  width: 40%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#p li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#p li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#p li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#p li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#p li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#p li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#p li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 1.25s;
  animation-duration: 4.5s;
}

#p li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#p li:nth-child(8) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#p li:nth-child(9) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#p li:nth-child(10) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#sh {
  position: absolute;
  top: 20%;
  left: 30%;
  height: 5vw;
  width: 40%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#sh li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#sh li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#sh li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#sh li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#sh li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#sh li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

.p--1 .p__img,
.p--1 .p__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/piercing-3.png");
}

.p--2 .p__img,
.p--2 .p__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/piercing-5.png");
}

.p--3 .p__img,
.p--3 .p__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/piercing-2.png");
}

.p--4 .p__img,
.p--4 .p__img--hover {
  background-image: url("https://bdt-site.s3.us-east-2.amazonaws.com/piercing-7.png");
}

.p__like {
  width: 18px;
}

.p__clock {
  width: 15px;
  vertical-align: middle;
  fill: #ad7d52;
}

.p__time {
  font-size: 12px;
  color: #ad7d52;
  vertical-align: middle;
  margin-left: 5px;
}

.p__clock-info {
  float: right;
}

.p__img {
  visibility: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 235px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.p__info-hover {
  position: absolute;
  padding: 16px;
  width: 100%;
  opacity: 0;
  top: 0;
}

.p__img--hover {
  transition: 0.2s all ease-out;
  background-size: cover;
  background-repeat: no-repeat;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  width: 100%;
  position: absolute;
  height: 22em;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  top: 0;
}

.p {
  margin-right: 25px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0, 1);
  background-color: #050505;
  width: 25em;
  height: 30em;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
}

.p:hover {
  box-shadow: 0px 30px 18px -8px rgba(0, 0, 0, 0.1);
  transform: scale(1.1, 1.1);
  border: 1px solid white;
}

.p__info {
  z-index: 2;
  background-color: #f3f3f3;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 7em 1em;
}

.p__category {
  display: inline-block;
  font-family: "Varela Round";
  font-size: 11px;
  letter-spacing: 5px;
  color: #88888a;
  text-transform: uppercase;
  position: relative;
}

.p__title {
  margin-top: 5px;
  margin-bottom: 10px;
  font-family: "Varela Round";
  color: #050505;
  text-transform: uppercase;
  position: relative;
}

.p__by {
  font-size: 12px;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
}

.p__author {
  font-weight: 600;
  text-decoration: none;
  color: #ad7d52;
}

.p:hover .p__img--hover {
  height: 100%;
}

.p:hover .p__info {
  background-color: transparent;
  position: relative;
}

.p:hover .p__info-hover {
  opacity: 1;
}

@media (min-width: 390px) {
  .piercing {
    flex-wrap: wrap;
  }
  .piercing_container {
    width: 100%;
  }
  .piercing_prices_items {
    width: 100%;
  }
  .piercing_artist {
    gap: 5em;
  }
  .piercing_artist article {
    z-index: 4;
  }
  .p {
    width: 20em !important;
  }
  .overlay-piercing-menu {
    width: 100%;
  }
  #p-mobile li {
    font-size: 1.8em !important;
  }
  #p li,
  #sh li {
    font-size: 1.5em !important;
  }
}
@media (min-width: 768px) {
  .piercing {
    flex-wrap: nowrap;
    justify-content: baseline;
  }
  .piercing_artist {
    gap: 0em;
    margin-top: 8em;
  }
  .overlay-piercing-menu {
    width: 50%;
  }
  #p li,
  #sh li {
    font-size: 1.5em !important;
  }
  .p {
    width: 19em;
  }
}
@media (min-width: 1024px) {
  .piercing {
    flex-wrap: nowrap;
    justify-content: center;
  }
  .piercing_container {
    width: 70%;
  }
  .piercing_prices_items {
    width: 50%;
  }
  .piercing_artist {
    gap: 5em;
    margin-top: 8em;
  }
  .overlay-piercing-menu {
    width: 50% !important;
  }
  #p > li,
  #sh li {
    font-size: 1.7em !important;
  }
  .p {
    width: 25em;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Piercing/Styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,UAAA;EACA,mCAAA;AADF;AAGE;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mCAAA;EACA,2CAAA;EACA,mDAAA;AADJ;AAIE;EACE,WAAA;AAFJ;AAII;EACE,cC/BM;EDgCN,gBAAA;AAFN;AAKI;EACE,cCzCK;ADsCX;AAOE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cC5CQ;ADuCZ;AAOI;EACE,UAAA;AALN;AAOM;EACE,cCvDG;ADkDX;AAQM;EACE,WAAA;EACA,gBAAA;AANR;AAWE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EAEA,gBAAA;EAEA,2CAAA;EACA,kDAAA;AAXJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EAEA,gBAAA;EAEA,2CAAA;EACA,kDAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EAEA,qJAAA;EAgBA,UAAA;AAhCF;AAkCE;EACE,gBAAA;AAhCJ;AAmCE;EACE,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EAEA,gBAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,8BAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAnCJ;AAqCI;EACE,UAAA;EACA,WAAA;AAnCN;AAsCI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AApCN;AAsCM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AApCR;AAuCM;EACE,gBAAA;EACA,cCrKG;ADgIX;AAyCI;EACE,0CAAA;AAvCN;AAyCM;EACE,YAAA;AAvCR;AA4CE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA1CJ;AA4CI;EACE,UAAA;EACA,WAAA;AA1CN;AA6CI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AA3CN;AA6CM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AA3CR;AA8CM;EACE,gBAAA;EACA,cCnNG;ADuKX;AAgDI;EACE,0CAAA;AA9CN;AAgDM;EACE,YAAA;AA9CR;AAmDE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAjDJ;AAmDI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAjDN;AAoDI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AAlDN;AAoDM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAlDR;AAqDM;EACE,gBAAA;EACA,cCnQG;ADgNX;AAuDI;EACE,0CAAA;AArDN;AAuDM;EACE,YAAA;AArDR;;AA2DA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AAxDF;;AA2DA;EACE;IACE,UAAA;IACA,2BAAA;EAxDF;EA2DA;IACE,UAAA;IACA,wBAAA;EAzDF;AACF;AA4DA;EACE;IACE,mBAAA;EA1DF;EA6DA;IACE,iBAAA;EA3DF;AACF;AA8DA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5DF;EAgEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9DF;EAiEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/DF;EAkEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhEF;EAmEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjEF;EAoEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlEF;EAqEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnEF;EAsEA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApEF;EAuEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArEF;EAwEA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtEF;AACF;AA0EA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxEF;EA4EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1EF;EA6EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA3EF;EA8EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5EF;EA+EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA7EF;EAgFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9EF;EAiFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/EF;EAkFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhFF;EAmFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjFF;EAoFA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAlFF;EAsFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApFF;EAuFA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EArFF;EAyFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvFF;EA0FA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAxFF;EA4FA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1FF;EA6FA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA3FF;EA8FA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EA5FF;AACF;AAgGA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9FF;EAkGA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhGF;EAmGA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjGF;EAoGA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlGF;EAqGA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnGF;EAsGA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApGF;EAuGA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArGF;EAwGA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtGF;EAyGA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvGF;EA0GA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxGF;EA2GA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzGF;EA4GA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1GF;AACF;AA8GA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5GF;EAgHA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9GF;EAiHA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/GF;EAkHA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhHF;EAmHA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjHF;EAoHA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlHF;EAqHA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnHF;EAsHA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApHF;EAuHA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArHF;EAwHA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtHF;EAyHA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvHF;EA0HA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxHF;AACF;AA4HA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1HF;EA8HA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5HF;EA+HA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA7HF;EAgIA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9HF;EAiIA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/HF;EAkIA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhIF;EAmIA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjIF;EAoIA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlIF;EAqIA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnIF;EAsIA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApIF;EAuIA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArIF;EAwIA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtIF;AACF;AA0IA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxIF;EA4IA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1IF;EA6IA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA3IF;EA8IA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5IF;EA+IA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA7IF;EAgJA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9IF;EAiJA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/IF;EAkJA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhJF;EAmJA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjJF;EAoJA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAlJF;EAqJA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnJF;EAsJA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApJF;AACF;AAwJA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtJF;EA0JA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxJF;EA2JA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAzJF;EA4JA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1JF;EA6JA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA3JF;EA8JA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5JF;EA+JA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA7JF;EAgKA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9JF;EAiKA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/JF;EAkKA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAhKF;EAmKA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjKF;EAoKA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EAlKF;AACF;AAsKA;;EAEE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCCl2BU;AD8rBZ;;AAuKA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EAEA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AArKF;;AAwKA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AArKF;;AAwKA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AArKF;;AAyKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAvKF;;AA0KA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AAvKF;;AA0KA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAvKF;;AA0KA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAvKF;;AA0KA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAvKF;;AA0KA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAvKF;;AA0KA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAvKF;;AA0KA;;EAEE,mFAAA;AAvKF;;AA0KA;;EAEE,mFAAA;AAvKF;;AA0KA;;EAEE,mFAAA;AAvKF;;AA0KA;;EAEE,mFAAA;AAvKF;;AA0KA;EACE,WAAA;AAvKF;;AA0KA;EACE,WAAA;EACA,sBAAA;EACA,aAAA;AAvKF;;AA0KA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AAvKF;;AA0KA;EACE,YAAA;AAvKF;;AA0KA;EACE,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;EACA,aAAA;EACA,4BAAA;EACA,6BAAA;AAvKF;;AA0KA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AAvKF;;AA0KA;EACE,6BAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,8CAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,MAAA;AAvKF;;AA0KA;EACE,kBAAA;EACA,qDAAA;EACA,yBCtkCU;EDukCV,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,2BAAA;EACA,8CAAA;AAxKF;;AA2KA;EACE,iDAAA;EACA,0BAAA;EACA,uBAAA;AAxKF;;AA2KA;EACE,UAAA;EACA,yBCvlCU;EDwlCV,+BAAA;EACA,gCAAA;EACA,gBAAA;AAxKF;;AA2KA;EACE,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cCnmCS;EDomCT,yBAAA;EACA,kBAAA;AAxKF;;AA2KA;EACE,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,cC7mCU;ED8mCV,yBAAA;EACA,kBAAA;AAxKF;;AA2KA;EACE,eAAA;EACA,kCAAA;EACA,gBAAA;AAxKF;;AA2KA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AAxKF;;AA2KA;EACE,YAAA;AAxKF;;AA4KA;EAEE,6BAAA;EACA,kBAAA;AA1KF;;AA6KA;EACE,UAAA;AA1KF;;AE59BE;EF0oCA;IACE,eAAA;EA1KF;EA4KE;IACE,WAAA;EA1KJ;EA6KE;IACE,WAAA;EA3KJ;EA8KE;IACE,QAAA;EA5KJ;EA8KI;IACE,UAAA;EA5KN;EAiLF;IACE,sBAAA;EA/KA;EAkLA;IACE,WAAA;EAhLF;EAmLA;IACE,2BAAA;EAjLF;EAoLA;;IAEE,2BAAA;EAlLF;AACF;AEr/BE;EF2qCA;IACE,iBAAA;IACA,yBAAA;EAnLF;EAqLE;IACE,QAAA;IACA,eAAA;EAnLJ;EAuLA;IACE,UAAA;EArLF;EAwLA;;IAEE,2BAAA;EAtLF;EAyLA;IACE,WAAA;EAvLF;AACF;AEngCE;EF8rCA;IACE,iBAAA;IACA,uBAAA;EAxLF;EA0LE;IACE,UAAA;EAxLJ;EA2LE;IACE,UAAA;EAzLJ;EA4LE;IACE,QAAA;IACA,eAAA;EA1LJ;EA8LA;IACE,qBAAA;EA5LF;EA+LA;;IAEE,2BAAA;EA7LF;EAgMA;IACE,WAAA;EA9LF;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n\n.piercing {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  filter: blur(100px);\n  position: relative;\n  animation: blurry 2s ease-in-out forwards;\n  gap: 1em;\n  font-family: \"Varela Round\";\n  padding: 0;\n  z-index: 1;\n  transform: translate3d(0, 0, 0.1px);\n\n  &_container {\n    display: flex;\n    margin-top: 8em;\n    flex-direction: column;\n    width: 70%;\n    height: 50em;\n    position: relative;\n    gap: 4em;\n    font-family: \"Varela Round\";\n    justify-content: baseline;\n    padding: 2em;\n    overflow-y: scroll;\n    z-index: 1;\n    transform: translate3d(0, 0, 0.1px);\n    animation: fadeIn 0.3s ease-in-out forwards;\n    transition: all 10s cubic-bezier(0.77, 0, 0.175, 1);\n  }\n\n  &_instructions {\n    width: 100%;\n\n    &>p {\n      color: $bdt-white;\n      font-size: 1.2em;\n    }\n\n    &>h2 {\n      color: $bdt-gold;\n    }\n  }\n\n  &_prices {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    color: $bdt-white;\n\n    &_items {\n      width: 40%;\n\n      &>h2 {\n        color: $bdt-gold;\n      }\n\n      &>li {\n        margin: 2em;\n        font-size: 1.2em;\n      }\n    }\n  }\n\n  &_artist {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    // margin-top: 8em;\n    padding: 0 0.5em;\n\n    animation: fadeIn 0.3s ease-in-out forwards;\n    transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  }\n\n  &_form {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    // margin-top: 8em;\n    padding: 0 0.5em;\n\n    animation: fadeIn 0.3s ease-in-out forwards;\n    transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);\n  }\n}\n\n.overlay-piercing-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n  //   margin-top: 6em;\n  width: 25%;\n  height: 50em;\n  opacity: 1;\n  position: relative;\n\n  background-image: linear-gradient(to top,\n      #050505,\n      #352336,\n      #753753,\n      #b84f57,\n      #eb7847,\n      #eb7847,\n      #eb7847,\n      #eb7847,\n      #b84f57,\n      #753753,\n      #352336,\n      #050505);\n\n  //   background-image: linear-gradient(to top, #050505, #1b111f, #35122d, #540b2f, #710025, #84001f, #950015, #a40002, #b70002, #c90002, #dd0001, #f00000);\n\n  z-index: 5;\n\n  &_title {\n    margin-top: 10em;\n  }\n\n  &_subtitle {\n    font-family: \"Varela Round\";\n    font-size: 11px;\n    letter-spacing: 5px;\n    line-height: 2em;\n    color: white;\n    text-transform: uppercase;\n    position: relative;\n    // top: 16%;\n    padding: 1em 4em;\n  }\n\n  &_shirts {\n    cursor: pointer;\n    position: relative;\n    top: 20%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(0, 0, 0, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n\n    &_img {\n      width: 4em;\n      height: 4em;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n\n  &_tattoo-care {\n    cursor: pointer;\n    position: relative;\n    top: 22%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(136, 136, 138, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n\n    &_img {\n      width: 4em;\n      height: 4em;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n\n  &_jewelry {\n    cursor: pointer;\n    position: relative;\n    top: 24%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(136, 136, 138, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n\n    &_img {\n      width: 4em;\n      height: 4em;\n      border-radius: 4px;\n      overflow: hidden;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  object-position: center center;\n  object-fit: cover;\n  image-rendering: auto;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes blurry {\n  0% {\n    filter: blur(100px);\n  }\n\n  100% {\n    filter: blur(0px);\n  }\n}\n\n@keyframes flickerL {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  100% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n    // opacity: 1;\n  }\n}\n\n@keyframes flickerO {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  72.66667% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n\n  73.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  74% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n\n  74.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  75.33333% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n\n  75.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  94.44444% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n@keyframes flickerA {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  88.86667% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  88.88889% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n@keyframes flickerD {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  83.31111% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  83.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n@keyframes flickerI {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  77.75556% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  77.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n@keyframes flickerN {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  72.2% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  72.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n@keyframes flickerG {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  66.64444% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n\n  66.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n#p-mobile li,\n#sh-mobile li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.4vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: $bdt-white;\n}\n\n#p {\n  position: absolute;\n  top: 20%;\n  left: 0%;\n  //   right: 0;\n  height: 5vw;\n  width: 40%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n\n#p li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n\n#p li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(6) {\n  animation-name: flickerN;\n  animation-delay: 1.25s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(7) {\n  animation-name: flickerG;\n  animation-delay: 1.5s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(8) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(9) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n\n#p li:nth-child(10) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n\n\n#sh {\n  position: absolute;\n  top: 20%;\n  left: 30%;\n  // right: 0%;\n  height: 5vw;\n  width: 40%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n\n#sh li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n\n#sh li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n\n#sh li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n\n#sh li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n\n#sh li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n\n#sh li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n\n.p--1 .p__img,\n.p--1 .p__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/piercing-3.png\");\n}\n\n.p--2 .p__img,\n.p--2 .p__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/piercing-5.png\");\n}\n\n.p--3 .p__img,\n.p--3 .p__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/piercing-2.png\");\n}\n\n.p--4 .p__img,\n.p--4 .p__img--hover {\n  background-image: url(\"https://bdt-site.s3.us-east-2.amazonaws.com/piercing-7.png\");\n}\n\n.p__like {\n  width: 18px;\n}\n\n.p__clock {\n  width: 15px;\n  vertical-align: middle;\n  fill: #ad7d52;\n}\n\n.p__time {\n  font-size: 12px;\n  color: #ad7d52;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\n.p__clock-info {\n  float: right;\n}\n\n.p__img {\n  visibility: hidden;\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 235px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.p__info-hover {\n  position: absolute;\n  padding: 16px;\n  width: 100%;\n  opacity: 0;\n  top: 0;\n}\n\n.p__img--hover {\n  transition: 0.2s all ease-out;\n  background-size: cover;\n  background-repeat: no-repeat;\n  transform: translateY(-1px);\n  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n  width: 100%;\n  position: absolute;\n  height: 22em;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  top: 0;\n}\n\n.p {\n  margin-right: 25px;\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0, 1);\n  background-color: $bdt-black;\n  width: 25em;\n  height: 30em;\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n\n  transform: translateY(-1px);\n  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n}\n\n.p:hover {\n  box-shadow: 0px 30px 18px -8px rgba(0, 0, 0, 0.1);\n  transform: scale(1.1, 1.1);\n  border: 1px solid white;\n}\n\n.p__info {\n  z-index: 2;\n  background-color: $bdt-white;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  padding: 7em 1em;\n}\n\n.p__category {\n  display: inline-block;\n  font-family: \"Varela Round\";\n  font-size: 11px;\n  letter-spacing: 5px;\n  color: $bdt-gray;\n  text-transform: uppercase;\n  position: relative;\n}\n\n.p__title {\n  margin-top: 5px;\n  margin-bottom: 10px;\n  font-family: \"Varela Round\";\n  color: $bdt-black;\n  text-transform: uppercase;\n  position: relative;\n}\n\n.p__by {\n  font-size: 12px;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 500;\n}\n\n.p__author {\n  font-weight: 600;\n  text-decoration: none;\n  color: #ad7d52;\n}\n\n.p:hover .p__img--hover {\n  height: 100%;\n  //   opacity: 0.3;\n}\n\n.p:hover .p__info {\n  //   background-color: white;\n  background-color: transparent;\n  position: relative;\n}\n\n.p:hover .p__info-hover {\n  opacity: 1;\n}\n\n@include screen-sm {\n  .piercing {\n    flex-wrap: wrap;\n\n    &_container {\n      width: 100%;\n    }\n\n    &_prices_items {\n      width: 100%;\n    }\n\n    &_artist {\n      gap: 5em;\n\n      & article {\n        z-index: 4;\n      }\n    }\n  }\n\n.p {\n  width: 20em !important;\n}\n\n  .overlay-piercing-menu {\n    width: 100%;\n  }\n\n  #p-mobile li {\n    font-size: 1.8em !important;\n  }\n\n  #p li,\n  #sh li {\n    font-size: 1.5em !important;\n  }\n}\n\n@include screen-md {\n  .piercing {\n    flex-wrap: nowrap;\n    justify-content: baseline;\n\n    &_artist {\n      gap: 0em;\n      margin-top: 8em;\n    }\n  }\n\n  .overlay-piercing-menu {\n    width: 50%;\n  }\n\n  #p li,\n  #sh li {\n    font-size: 1.5em !important;\n  }\n\n  .p {\n    width: 19em;\n  }\n}\n\n@include screen-lg {\n  .piercing {\n    flex-wrap: nowrap;\n    justify-content: center;\n\n    &_container {\n      width: 70%;\n    }\n\n    &_prices_items {\n      width: 50%;\n    }\n\n    &_artist {\n      gap: 5em;\n      margin-top: 8em;\n    }\n  }\n\n  .overlay-piercing-menu {\n    width: 50% !important;\n  }\n\n  #p>li,\n  #sh li {\n    font-size: 1.7em !important;\n  }\n\n  .p {\n    width: 25em;\n  }\n}","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
